import { ETC } from '../types';
export default {
  type: ETC,
  service: 'CW Geth',
  url: 'https://etc-geth.0xinfra.com/',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
